import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext, SttPrivilegeList } from '../../../sporttia/all';
import { updateElementInArray } from '../../../lib/utils';
import { useCanModifyConfiguration } from './useCanModifyConfiguration';

type Privilege = {
    id: number;
    name?: string;
    description?: string;
    active: boolean;
};

type PrivilegesResponse = {
    rows: Privilege[];
    count?: number;
};

export default function ConfigurationPrivileges(): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const canModify = useCanModifyConfiguration();
    const [privileges, setPrivileges] = useState<
        PrivilegesResponse | undefined
    >();

    // Only show this privileges
    const privilegesToShow = [6, 9, 13, 19, 23, 24, 25, 26, 27];

    /**
     * Load privileges
     */
    const loadPrivileges = (): void => {
        cxt?.api('GET', `/scs/${cxt.sc?.id}/privileges`, {
            success: (r: PrivilegesResponse) => {
                setPrivileges(r);
            },
        });
    };

    /**
     * Toggle privilege
     */
    const togglePrivilege = ({
        id,
        value,
    }: {
        id: number;
        value: boolean;
    }): void => {
        // SttPrivilegeList no sabe desactivar sus interruptores: sin permiso
        // para modificar, el cambio se ignora.
        if (!canModify) return;
        const idPrivilege = id;
        const privilege = privileges?.rows.find(
            (privilege: any) => privilege.id === idPrivilege,
        );
        if (privilege) {
            privilege.active = value;

            if (privilege.active) {
                cxt?.api(
                    'POST',
                    `/scs/${cxt.sc?.id}/privileges/${idPrivilege}`,
                    {
                        success: () => {
                            setPrivileges({
                                rows: updateElementInArray(
                                    privileges?.rows || [],
                                    privilege,
                                ),
                            });
                        },
                    },
                );
            } else {
                cxt?.api(
                    'DELETE',
                    `/scs/${cxt.sc?.id}/privileges/${idPrivilege}`,
                    {
                        success: () => {
                            setPrivileges({
                                rows: updateElementInArray(
                                    privileges?.rows || [],
                                    privilege,
                                ),
                            });
                        },
                    },
                );
            }
        }
    };

    /**
     * SC changes
     */
    useEffect(() => {
        if (cxt?.sc?.id) loadPrivileges();
    }, [cxt?.sc?.id]);

    // -----| Render |-----
    return (
        <>
            {privileges && (
                <SttPrivilegeList
                    privileges={
                        privileges.rows.filter((priv: any) =>
                            privilegesToShow.includes(priv.id),
                        ) as any
                    }
                    onToggle={togglePrivilege as any}
                    title={t('Privilege')}
                />
            )}
        </>
    );
}
